function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAjaxLoaderRed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "lds-spinner",
    width: "64px",
    height: "64px",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 100 100",
    preserveAspectRatio: "xMidYMid",
    style: {
      shapeRendering: "auto",
      animationPlayState: "running",
      animationDelay: "0s",
      background: "none"
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "rotate(0 50 50)",
    style: {
      animationPlayState: "running",
      animationDelay: "0s"
    }
  }, /*#__PURE__*/React.createElement("rect", {
    x: 41,
    y: 11,
    rx: 41,
    ry: 11,
    width: 18,
    height: 18,
    fill: "red",
    style: {
      animationPlayState: "running",
      animationDelay: "0s"
    }
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "1;0",
    keyTimes: "0;1",
    dur: "1s",
    begin: "-0.875s",
    repeatCount: "indefinite",
    style: {
      animationPlayState: "running",
      animationDelay: "0s"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(45 50 50)",
    style: {
      animationPlayState: "running",
      animationDelay: "0s"
    }
  }, /*#__PURE__*/React.createElement("rect", {
    x: 41,
    y: 11,
    rx: 41,
    ry: 11,
    width: 18,
    height: 18,
    fill: "red",
    style: {
      animationPlayState: "running",
      animationDelay: "0s"
    }
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "1;0",
    keyTimes: "0;1",
    dur: "1s",
    begin: "-0.75s",
    repeatCount: "indefinite",
    style: {
      animationPlayState: "running",
      animationDelay: "0s"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(90 50 50)",
    style: {
      animationPlayState: "running",
      animationDelay: "0s"
    }
  }, /*#__PURE__*/React.createElement("rect", {
    x: 41,
    y: 11,
    rx: 41,
    ry: 11,
    width: 18,
    height: 18,
    fill: "red",
    style: {
      animationPlayState: "running",
      animationDelay: "0s"
    }
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "1;0",
    keyTimes: "0;1",
    dur: "1s",
    begin: "-0.625s",
    repeatCount: "indefinite",
    style: {
      animationPlayState: "running",
      animationDelay: "0s"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(135 50 50)",
    style: {
      animationPlayState: "running",
      animationDelay: "0s"
    }
  }, /*#__PURE__*/React.createElement("rect", {
    x: 41,
    y: 11,
    rx: 41,
    ry: 11,
    width: 18,
    height: 18,
    fill: "red",
    style: {
      animationPlayState: "running",
      animationDelay: "0s"
    }
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "1;0",
    keyTimes: "0;1",
    dur: "1s",
    begin: "-0.5s",
    repeatCount: "indefinite",
    style: {
      animationPlayState: "running",
      animationDelay: "0s"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(180 50 50)",
    style: {
      animationPlayState: "running",
      animationDelay: "0s"
    }
  }, /*#__PURE__*/React.createElement("rect", {
    x: 41,
    y: 11,
    rx: 41,
    ry: 11,
    width: 18,
    height: 18,
    fill: "red",
    style: {
      animationPlayState: "running",
      animationDelay: "0s"
    }
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "1;0",
    keyTimes: "0;1",
    dur: "1s",
    begin: "-0.375s",
    repeatCount: "indefinite",
    style: {
      animationPlayState: "running",
      animationDelay: "0s"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(225 50 50)",
    style: {
      animationPlayState: "running",
      animationDelay: "0s"
    }
  }, /*#__PURE__*/React.createElement("rect", {
    x: 41,
    y: 11,
    rx: 41,
    ry: 11,
    width: 18,
    height: 18,
    fill: "red",
    style: {
      animationPlayState: "running",
      animationDelay: "0s"
    }
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "1;0",
    keyTimes: "0;1",
    dur: "1s",
    begin: "-0.25s",
    repeatCount: "indefinite",
    style: {
      animationPlayState: "running",
      animationDelay: "0s"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(270 50 50)",
    style: {
      animationPlayState: "running",
      animationDelay: "0s"
    }
  }, /*#__PURE__*/React.createElement("rect", {
    x: 41,
    y: 11,
    rx: 41,
    ry: 11,
    width: 18,
    height: 18,
    fill: "red",
    style: {
      animationPlayState: "running",
      animationDelay: "0s"
    }
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "1;0",
    keyTimes: "0;1",
    dur: "1s",
    begin: "-0.125s",
    repeatCount: "indefinite",
    style: {
      animationPlayState: "running",
      animationDelay: "0s"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(315 50 50)",
    style: {
      animationPlayState: "running",
      animationDelay: "0s"
    }
  }, /*#__PURE__*/React.createElement("rect", {
    x: 41,
    y: 11,
    rx: 41,
    ry: 11,
    width: 18,
    height: 18,
    fill: "red",
    style: {
      animationPlayState: "running",
      animationDelay: "0s"
    }
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "1;0",
    keyTimes: "0;1",
    dur: "1s",
    begin: "0s",
    repeatCount: "indefinite",
    style: {
      animationPlayState: "running",
      animationDelay: "0s"
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAjaxLoaderRed);
export default __webpack_public_path__ + "static/media/ajax-loader-red.2750660cf5e4c7d19c5babfe955b2b80.svg";
export { ForwardRef as ReactComponent };